import { EnvironmentConfig } from '@me8eon/config'
import type { JwtTokenFn } from '@me8eon/authentication'

const BASE = `${EnvironmentConfig.nodeService}/service/incidents`

export type IncidentRecord = Record<string, unknown>

export interface ListIncidentsResponse {
  result: {
    queryResult: IncidentRecord[]
    message: string
  }
}

/**
 * Lists ServiceNow incidents from `nodeService`. Uses a plain `JwtTokenFn`, not
 * `AuthenticatedFetch`, whose `entraApiScope` token this endpoint rejects.
 */
export async function listIncidents(
  jwtTokenFn: JwtTokenFn,
  isActive: boolean,
): Promise<ListIncidentsResponse> {
  const response = await fetch(`${BASE}?isActive=${isActive}`, {
    headers: { Authorization: `Bearer ${await jwtTokenFn()}` },
  })
  if (!response.ok) throw new Error(`incidents/list failed: ${response.status}`)
  return response.json()
}
